import React, { useCallback, useEffect } from 'react';
import useFavoriteResourcesStore from 'graph/state/query-hooks/use-favorite-resources';
import { FavoriteResource, Resource } from '@monorepo/shared/src/providers/ResourcesProvider/types';
import WithQuery from '@monorepo/shared/src/components/common/WithQuery';
import NoContent from '@monorepo/shared/src/components/common/NoContent';
import ResourcesList from '@monorepo/shared/src/components/modules/Resources/ResourcesList';
import useResources from '@monorepo/shared/src/hooks/use-resources';
import ResourcesGrid from './ResourcesGrid';

const PinnedResources: React.FC = () => {
  const [store, { unpinResource }] = useFavoriteResourcesStore();
  const [
    { pinnedResources, filteredResources },
    { removeResource, setResources, setPinnedResources, setPinActions },
  ] = useResources();

  const handleOnPinClick = useCallback(
    async (resource: Resource, pinnedResourceId: number | undefined) => {
      try {
        await unpinResource(pinnedResourceId as number);
        setPinActions('UNPINNING');
        removeResource(resource);
      } catch (error) {
        console.log(error);
      }
    },
    [pinnedResources, unpinResource, setPinActions, removeResource]
  );

  useEffect(() => {
    setResources(
      store.resources.map((favoriteResource: FavoriteResource) => favoriteResource.resource)
    );
    setPinnedResources(store.resources);
  }, [store.isLoading]);

  return (
    <WithQuery loading={store.isLoading} error={store.error} ErrorComponent={NoContent}>
      <ResourcesGrid>
        <ResourcesList
          resources={filteredResources}
          pinnedResources={pinnedResources}
          areDisplayingPinnedResources={true}
          onPinClick={handleOnPinClick}
        />
      </ResourcesGrid>
    </WithQuery>
  );
};

export default PinnedResources;
